/* @ngInject */
function boardColumnsService (ConnectorWebService, CONSTANTS, Utils) {
  const service = {
    getBoardColumns,
    deleteBoardColumn,
    updateBoardColumn,
    createBoardColumn,
    defineStatusForDaysInColumn,
    getTasksForColumn,
    moveColumn,
    archiveAllTasks,
    moveColumnTask,
    getColumn
  }
  return service

  function getBoardColumns (boardId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BOARD_COLUMNS, [boardId])
    return ConnectorWebService.get(url)
  }

  function deleteBoardColumn (columnId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_COLUMNS_ID, [columnId])
    return ConnectorWebService.fnDelete(url)
  }

  function updateBoardColumn (columnId, payload) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_COLUMNS_ID, [columnId])
    return ConnectorWebService.put(url, payload)
  }

  function createBoardColumn (payload) {
    return ConnectorWebService.post(CONSTANTS.URL_COLUMNS, payload)
  }

  /**
   *
   * @param {Object} oColumn
   * @param {Number} oColumn.maximumDaysInColumn
   * @param {Object} oTask
   * @param {Number} oTask.daysInColumn
   */
  function defineStatusForDaysInColumn (oColumn, oTask) {
    var get50percent = function (day) {
      return (day / 10) * 5
    }

    var noColor = !oColumn.maximumDaysInColumn
    var timeToWarning = oTask.daysInColumn >= get50percent(oColumn.maximumDaysInColumn)
    var isDanger = oColumn.maximumDaysInColumn <= oTask.daysInColumn // Same as or greatest han the maximum time
    var isWarning = timeToWarning && !isDanger

    if (noColor) {
      return {
        status: null,
        class: ''
      }
    } else if (isDanger) {
      return {
        status: 'DANGER',
        class: 'ui red horizontal label'
      }
    } else if (isWarning) {
      return {
        status: 'WARNING',
        class: 'ui yellow horizontal label'
      }
    }
  }

  function getTasksForColumn (id, top, skip, filtersParam, search, ordernation) {
    const filters = {
      ...filtersParam
    }

    Object.keys(filters).forEach(key => {
      if (Array.isArray(filters[key]) && !filters[key].length) {
        delete filters[key]
      }
    })

    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_COLUMNS_ID_TASKS, [id])

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    if (filters) {
      if (filters.assignees && Array.isArray(filters.assignees)) {
        const assignees = filters.assignees.map(assignee => {
          if (typeof assignee === 'object') {
            return assignee.id
          }

          return assignee
        })

        delete filters.assignees
        url = Utils.addQueryStringFromArray(url, 'assignees', assignees)
      }

      if (filters.author && filters.author.id) {
        filters.author = filters.author.id
      }

      if (typeof filters.isArchived === 'undefined') {
        filters.isArchived = false
      }

      url = Utils.fnAddQueryToUrl(url, filters)
    }

    if (ordernation) {
      const { sort, order } = ordernation
      url = Utils.fnAddQueryToUrl(url, { $sort: sort, $order: order })
    }

    if (search) {
      url = Utils.fnAddQueryToUrl(url, { search })
    }

    return ConnectorWebService.get(url)
  }

  function moveColumn (columnId, direction) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_COLUMNS_ID_MOVE, [columnId])
    return ConnectorWebService.put(url, { direction })
  }

  function archiveAllTasks (columnId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_COLUMNS_ID_TASKS_ARCHIVE, [columnId])
    return ConnectorWebService.put(url)
  }

  function moveColumnTask (taskId, from, to, position) {
    return ConnectorWebService.put(CONSTANTS.URL_COLUMNS_MOVE, { taskId, from, to, position })
  }

  function getColumn (columnId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_COLUMNS_ID, [columnId])
    return ConnectorWebService.get(url)
  }
}

export { boardColumnsService }
